import type { SvgProps } from "react-native-svg"

import type { DeepRequired, MakeRequired, Nullable } from "@bounce/util"

import type { Tag } from "../types"

import BadgeIcon from "@bounce/assets/icons/Badge.svg"
import ClockIcon from "@bounce/assets/icons/Clock.svg"
import DiamondIcon from "@bounce/assets/icons/Diamond.svg"
import LocationPinIcon from "@bounce/assets/icons/LocationPin.svg"
import StarFilledIcon from "@bounce/assets/icons/Star-filled.svg"

// Add new tags here so they map to Icons
// unknown tag types are not rendered
export enum StoreTagType {
  Featured = "featured",
  HighlyRated = "highly_rated",
  MostPopular = "most_popular",
  OpenAllTime = "open_24_7",
  OpenLate = "open_late",
  Indoor = "indoor",
  Outdoor = "outdoor",
}

export const StoreTagTypeToIcon: Record<StoreTagType, React.FC<SvgProps>> = {
  [StoreTagType.Featured]: DiamondIcon,
  [StoreTagType.MostPopular]: BadgeIcon,
  [StoreTagType.HighlyRated]: StarFilledIcon,
  [StoreTagType.OpenLate]: ClockIcon,
  [StoreTagType.OpenAllTime]: ClockIcon,
  [StoreTagType.Indoor]: LocationPinIcon,
  [StoreTagType.Outdoor]: LocationPinIcon,
}

export const isKnownStoreTag = (tag: string): tag is StoreTagType => Object.values<string>(StoreTagType).includes(tag)

export const isHighlyRatedTag = (tag: string) => {
  const highlyRatedTags: string[] = [StoreTagType.HighlyRated, StoreTagType.Featured]

  return highlyRatedTags.includes(tag)
}

const hasAllTagFields = (tag: Nullable<Tag>): tag is DeepRequired<Tag> => {
  return !!tag?.colorHex && !!tag.key && isKnownStoreTag(tag.key) && !!tag.name && typeof tag.weight === "number"
}
type TagWithWeight = MakeRequired<Tag, "weight">

const sortStoreTags = (a: TagWithWeight, b: TagWithWeight) => b.weight - a.weight

export const filterAndSortTags = (tags: Nullable<Nullable<Tag>[]>) => {
  return tags?.filter(hasAllTagFields).sort(sortStoreTags) || []
}
